// extracted by mini-css-extract-plugin
export default {"select_wrapper":"RolesDropdown_select_wrapper__LzzCz","select_root":"RolesDropdown_select_root__qcPdB"};